import React, { useCallback, useState } from 'react';
import { SectionBase } from 'npo/pages/ReportBuilder/Components/SectionBase';
import Locations, { AddressValue } from './Locations';
import { getTotalPercentage } from './utils';
import { GuidanceTextResponse } from '../utils';
import JSON5 from 'json5';

interface SectionLocationProps {
  title?: string;
  subTitle?: string;
  helpText?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  guidanceText: GuidanceTextResponse;
  questionId: number | undefined;
  value?: AddressValue[] | string;
  onChange: (
    questionId: SectionLocationProps['questionId'],
    address: AddressValue[] | undefined,
  ) => unknown;
}

export const parseAddressValue = (
  value: SectionLocationProps['value'],
): AddressValue[] => {
  if (!value) return [];
  if (typeof value === 'string') {
    try {
      const parsed = JSON5.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }
  return Array.isArray(value) ? value : [];
};

const SectionLocation: React.FC<SectionLocationProps> = ({
  title,
  subTitle,
  helpText,
  error,
  guidanceText,
  questionId,
  value,
  onChange,
}) => {
  const [addresses] = useState<AddressValue[]>(parseAddressValue(value));
  const handleChange = useCallback(
    (address: AddressValue[]) => {
      onChange(
        questionId,
        getTotalPercentage(address) === 100 ? address : undefined,
      );
    },
    [onChange, questionId],
  );
  return (
    <SectionBase
      title={title}
      subTitle={subTitle}
      helpText={helpText}
      error={error}
      questionId={questionId}
      guidanceText={guidanceText}
    >
      <Locations addresses={addresses} onChange={handleChange} />
    </SectionBase>
  );
};

export default SectionLocation;
